import { styled } from '@mui/material';
import { CoreBox } from '@youscience/core';

export const StyledTeacherButtonGroup = styled(CoreBox)(({ theme }) => ({
  display: 'flex',
  gap: '0.25rem',

  [theme.breakpoints.down('md')]: {
    alignSelf: 'stretch',
  },
}));
